import { Avatar, Card, Col, Layout, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useState } from "react";
import Sidebar from "./sidebar";
import { useSelector } from "react-redux";
import { getImgUrl } from "../../../utils";
const { Content } = Layout;

const FeedbackLayout = ({
  children,
  feedbackId,
}: {
  children: ReactElement;
  feedbackId: string;
}): ReactElement => {
  const { feedbackInfo } = useSelector((state) => (state as any)?.authReducer);

  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <section className="">
          <Row gutter={16}>
            <Col span={6}>
              <Card
                className="shop-sedebar card-padding-none h-100"
                cover={
                  <div className="show-details-inner-content">
                    <div className="shop-image-content">
                      <div className="pt-4">
                        <div className="mb-3">
                          <Avatar
                            size={150}
                            src={getImgUrl(feedbackInfo?.customerImage)}
                            className="shadow"
                          />
                        </div>
                        <div className="pt-3">
                          <h4>
                            {feedbackInfo?.customerName?.toUpperCase()}{" "}
                            <small>({feedbackInfo?.customerType})</small>
                          </h4>
                          <div className="mb-2">
                            <span
                              className="radius-btn active-btn px-5"
                              style={{ fontSize: 14 }}
                            >
                              <span>
                                {feedbackInfo?.customerContact?.split("+88")}
                              </span>
                            </span>
                          </div>
                          {/* <small>{feedbackInfo?.orderId}</small> */}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
                {/* <Sidebar feedbackId={feedbackId} /> */}
              </Card>
            </Col>
            <Col span={18}>
              <Card
                className="product-information-show-tab-wrapper"
                size="small"
              >
                <Layout>
                  <Content className="main-content-layout">{children}</Content>
                </Layout>
              </Card>
            </Col>
          </Row>
        </section>
      </Layout>
    </React.Fragment>
  );
};

FeedbackLayout.propType = {
  children: PropTypes.element,
};

export default FeedbackLayout;
